export default {
  acceptTermsRequired: 'कृपया नियम और शर्तें स्वीकार करें',
  accountNumber: 'खाता संख्या',
  acknowledgeText: 'स्वीकारें',
  acknowledgedText: 'स्वीकार किया',
  active: 'सक्रिय',
  activeBookings: 'सक्रिय बुकिंग',
  activeBucketsText: 'सक्रिय बकेट',
  activeToday: 'आज सक्रिय',
  adminRole: 'एडमिन — प्रबंध निदेशक',
  advance: 'अग्रिम',
  advancePaid: 'अग्रिम भुगतान',
  advancePaidLabel: 'अग्रिम',
  agreeTermsCheckbox: 'मैंने सभी नियम और शर्तें पढ़ी हैं और स्वीकार की हैं',
  agreement: 'नियम और समझौता',
  alertLog: 'अलर्ट लॉग',
  alertText: 'अलर्ट',
  alerts: 'अलर्ट',
  allAlerts: 'सभी चेतावनियाँ',
  allLoaded: 'सभी लोड',
  allMachinesOk: 'सभी मशीनें ठीक चल रही हैं।',
  allStats: 'पूर्ण आंकड़े',
  allowedText: 'अनुमत',
  amount: 'राशि',
  apiHealthTitle: 'API स्वास्थ्य',
  apiSloAlertsTitle: 'API SLO अलर्ट',
  appName: 'डेभलपमेन्ट एक्सप्रेस',
  approvals: 'अनुमोदन',
  approveAndDispatch: 'स्वीकृत करें और मशीन भेजें',
  approved: 'स्वीकृत',
  assignedOperator: 'नियुक्त ऑपरेटर',
  attemptsLabel: 'प्रयास',
  attendance: 'उपस्थिति',
  auditLogs: 'ऑडिट लॉग्स',
  available: 'उपलब्ध',
  availableMachinery: 'उपलब्ध मशीनरी',
  availableNow: 'अभी उपलब्ध',
  avgRating: 'औसत रेटिंग',
  awaitingClientFeedback: 'क्लाइंट फीडबैक की प्रतीक्षा',
  awaitingDispatch: 'डिस्पैच की प्रतीक्षा',
  back: 'वापस जाएं',
  backToLogin: 'लॉगिन पर वापस जाएं',
  bank: 'बैंक',
  bankDetailsTitle: 'बैंक विवरण',
  baseAmount: 'मूल राशि',
  billingWallet: 'वॉलेट और बिलिंग',
  blacklistWarning: '⛔ ब्ल्याकलिस्ट चेतावनी',
  blockedRateText: 'ब्लॉक दर',
  blockedText: 'ब्लॉक्ड',
  bookMachine: 'मेसिन बुक गर्नुहोस्',
  bookMachineAction: 'मशीन बुक करें',
  bookNow: 'अभी बुक करें',
  bookingConfirm: 'बुकिंग पुष्टि करें',
  bookingCostCalculator: 'बुकिंग और लागत कैलकुलेटर',
  bookingFailedGeneric: 'बुकिंग विफल। पुनः प्रयास करें।',
  bookingHistory: 'बुकिंग इतिहास',
  bookingReportTitle: 'बुकिंग रिपोर्ट',
  bookingScheduleSummary: 'दिन और महीने अनुसार बुकिंग शेड्यूल',
  bookingSelectMachineFirst: 'जारी रखने के लिए फ्लीट से मशीन चुनें।',
  bookingStepChoose: 'मशीन चुनें',
  bookingStepConfirm: 'पुष्टि और भुगतान',
  bookingStepCost: 'लागत और तारीख',
  bookingType: 'बुकिंग प्रकार चुनें',
  bookingTypeLabel: 'बुकिंग प्रकार',
  bookingTypeText: 'बुकिंग प्रकार',
  bookingsCount: '{count} बुकिंग',
  bookingsScheduleHint: 'क्लाइंट बुकिंग करने पर दिनवार शेड्यूल यहाँ दिखेगा।',
  burstText: 'बर्स्ट',
  busy: 'व्यस्त',
  callNow: 'अभी कॉल करें',
  cancel: 'रद्द करें',
  cancelAction: 'रद्द करें',
  cancelBooking: 'बुकिंग रद्द करें',
  cancelBookingPrompt: 'बुकिंग रद्द करें?',
  cancelPolicy: 'रद्दीकरण नीति',
  cancelText: 'रद्द',
  cancelWarning: 'क्या आप रद्द करना चाहते हैं?',
  changeLanguage: 'भाषा परिवर्तन',
  changeMachine: 'मशीन बदलें',
  changeMobileNumber: 'Change mobile number',
  chipAction: 'क्रिया',
  chipActor: 'कर्ता',
  chipEntity: 'एंटिटी',
  chipFrom: 'से',
  chipMeta: 'मेटा',
  chipRole: 'भूमिका',
  chipTo: 'तक',
  clearAll: 'सभी साफ करें',
  client: 'ग्राहक',
  clientFeedbackLabel: 'क्लाइंट फीडबैक',
  clientPortal: 'क्लाइन्ट पोर्टल',
  clientRatingsTitle: 'क्लाइंट रेटिंग और सुझाव',
  clientRole: 'क्लाइंट (ठेकेदार)',
  clients: 'ग्राहक',
  commission: 'कमीशन',
  commission15: 'कमीशन 15%',
  commissionPaid: 'कमीशन भुगतान',
  commissionRate: 'सकल बिलिंग का 15%',
  company: 'कंपनी',
  companyDetailsTitle: 'कंपनी विवरण',
  completeBookings: 'पूर्ण बुकिंग',
  completedBookings: 'पूर्ण बुकिंग',
  condition: 'स्थिति',
  confirm: 'पुष्टि गर्नुहोस्',
  confirmBooking: 'बुकिंग पुष्टि करें',
  confirmBookingAction: 'बुकिंग की पुष्टि करें',
  confirmCancel: 'रद्दीकरण पुष्टि करें',
  confirmPassword: 'Confirm password',
  confirmRetry: 'पुनः प्रयास की पुष्टि करें',
  contactCompany: 'डेवलपमेंट एक्सप्रेस से संपर्क करें',
  costCalculator: 'लागत कैलकुलेटर',
  crawlerNoRto: 'क्रॉलर (RTO नहीं)',
  currentlyDeployed: 'वर्तमान में तैनात',
  customAmount: 'कस्टम राशि (UPI/कार्ड ₹1 से)',
  cycles: "चक्र",
  dailyWorkReport: 'दैनिक कार्य रिपोर्ट',
  dashboard: 'ड्यासबोर्ड',
  date: 'दिनांक',
  dayMachinesLabel: 'मशीनें',
  days: 'दिन',
  daysUnit: 'दिन',
  directContactBlacklist: 'सीधा संपर्क = ब्लैकलिस्ट',
  directContactProhibited: 'सीधा संपर्क सख्त वर्जित',
  directContactProhibitedText: 'सीधा संपर्क सख्त प्रतिबंधित',
  dispatched: 'भेजा गया',
  dlqMonitor: 'DLQ मॉनिटर',
  docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नहीं)',
  docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड व्यू)',
  docIdentity: 'PAN / आधार',
  docInsurance: 'बीमा प्रमाणपत्र',
  docInsuranceOptional: 'बीमा / उपकरण कवर (यदि उपलब्ध)',
  docMachineInvoice: 'मशीन खरीद / इनवॉइस',
  docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
  docRcBook: 'RC बुक (RTO पंजीकरण प्रमाणपत्र)',
  documentUploadTitle: 'दस्तावेज़ अपलोड',
  documents: 'दस्तावेज़ अपलोड',
  download: 'डाउनलोड',
  drawerMenu: 'मेनू',
  earnings: 'कमाई',
  email: 'ईमेल सहायता',
  emailAddress: 'इमेल ठेगाना',
  emailAddressLabel: 'ईमेल पता',
  expandBookingHint: 'पूरी बुकिंग, रद्द करें और ऑपरेटर रेटिंग के लिए नीचे महीना/दिन सेक्शन expand करें।',
  experience: 'अनुभव',
  exportCsv: 'CSV एक्सपोर्ट',
  failedText: 'असफल',
  feedbackAfterDispatch: 'मशीन डिस्पैच के बाद ऑपरेटर रेटिंग उपलब्ध होगी।',
  feedbackStatusAfterDispatch: 'डिस्पैच के बाद',
  feedbackStatusRateNow: 'ऑपरेटर रेट करें ↓',
  filterAll: 'सभी',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'लंबित',
  filterDisputed: 'विवादित',
  forgotPasswordChooseMethod: 'Choose email link or SMS OTP to reset your password.',
  forgotPasswordEmailDevHint: 'Local dev: open the API server terminal and copy the “Password reset link (development)” URL.',
  forgotPasswordEmailHint: 'Enter your registered admin email address.',
  forgotPasswordFailed: 'Could not send reset link. Please try again.',
  forgotPasswordIntro: 'We will email a secure reset link to your registered email address.',
  forgotPasswordInvalidEmail: 'Please enter a valid email address.',
  forgotPasswordInvalidOtp: 'Enter the 6-digit OTP from SMS.',
  forgotPasswordInvalidPhone: 'Please enter a valid 10-digit mobile number.',
  forgotPasswordLink: 'Forgot password?',
  forgotPasswordOtpSentTo: 'OTP sent to',
  forgotPasswordPhoneHint: 'Enter your registered mobile number. Reset link goes to the email on your account.',
  forgotPasswordSendOtp: 'Send OTP',
  forgotPasswordSending: 'Sending...',
  forgotPasswordSendingOtp: 'Sending OTP...',
  forgotPasswordSmsDevHint: 'SMS not configured in production yet — in development, check server logs for the OTP code.',
  forgotPasswordSmsFailed: 'Could not send OTP. Please try again.',
  forgotPasswordSmsHint: 'Enter your registered mobile number. A 6-digit OTP will be sent by SMS.',
  forgotPasswordSmsSuccess: 'If an account exists, OTP was sent to the registered mobile number.',
  forgotPasswordSubmit: 'Send reset link',
  forgotPasswordSuccess: 'If an account exists, reset instructions were sent to the registered email.',
  forgotPasswordTitle: 'Reset your password',
  formLabel: 'फॉर्म',
  fuel: 'ईंधन',
  fuelColon: 'ईंधन:',
  fuelHistoryTitle: 'ईंधन इतिहास',
  fuelLevel: 'ईंधन स्तर',
  fuelLevelUpdate: 'फ्यूल स्तर अपडेट',
  fuelNotePlaceholder: 'नोट: भरा / उपयोग ईंधन...',
  fullName: 'पूरा नाम',
  goBook: '→ मशीन बुक करें',
  gpsLiveLabel: '🟢 GPS लाइव',
  grandTotal: 'कुल योग',
  grandTotalText: 'कुल योग',
  gross: 'सकल',
  grossBilling: 'सकल बिलिंग',
  gst18: 'GST (18%)',
  gstInvoice: 'GST इनवॉइस',
  gstInvoices: 'GST इनवॉइस',
  gstin: 'GSTIN',
  hide: 'छुपाएं',
  highTrend: 'HIGH ट्रेंड',
  hitsText: 'हिट्स',
  hmrHrs: 'घंटे',
  hmrToday: 'आज का HMR',
  hmrTotal: 'कुल HMR',
  home: 'होम',
  hours: 'घंटे',
  hrsUnit: 'घंटे',
  idle: 'निष्क्रिय',
  ifsc: 'IFSC',
  ignition: 'इग्निशन',
  importantInfo: 'मशीन मालिकों के लिए महत्वपूर्ण जानकारी',
  instantCost: 'त्वरित लागत कैलकुलेटर',
  invoiceNotAvailableCancelled: 'इनवॉइस उपलब्ध नहीं (रद्द)',
  iot: 'IoT और GPS',
  issueReportTitle: 'समस्या रिपोर्ट',
  issueReportedSuccess: 'इश्यू यशस्वीरित्या नोंदवला!',
  issues: 'समस्याएं',
  joinUsAction: 'Join Us — मुफ्त रजिस्टर करें',
  joinUsBanner: 'मशीन किराए पर चाहिए?',
  joinUsHint: 'नए ग्राहक? JCB, excavator, crane बुक करने के लिए मुफ्त रजिस्टर करें।',
  landingCtaApp: 'Development Express खोलें',
  landingFeatBook: 'मिनटों में बुकिंग',
  landingFeatBookDesc: 'JCB, excavator, crane — live availability.',
  landingFeatPay: 'Wallet payments',
  landingFeatPayDesc: 'GST invoice, transparent billing.',
  landingFeatTrack: 'Live GPS',
  landingFeatTrackDesc: 'हर घंटे machine location पता करें।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'महाराष्ट्र का smart machinery rental.',
  landingSocialProof: 'महाराष्ट्र भर के builders और contractors जुड़े हैं।',
  landingStatMachines: 'मशीनें',
  landingStatRating: 'रेटिंग',
  landingTrustLine: 'Wallet-only · GST · Secured',
  lastRefreshed: 'अंतिम रिफ्रेश',
  live: 'लाइव',
  liveBookAvail: 'बुकिंग के बाद लाइव फीड उपलब्ध',
  liveCamera: '360° लाइव कैमरा — बुकिंग के बाद',
  liveMachineLocation: 'लाइव मशीन स्थान',
  liveText: 'लाइव',
  liveTracking: 'लाइव ट्रैकिंग',
  loadMoreAlerts: 'और अलर्ट लोड करें',
  loadMoreAttendance: 'और उपस्थिति लोड करें',
  loadMoreBookings: 'और बुकिंग लोड करें',
  loadMoreDlq: 'और DLQ लोड करें',
  loadMoreFuelLogs: 'और फ्यूल लॉग लोड करें',
  loadMoreLogs: 'और लॉग लोड करें',
  loadMoreMachines: 'और मशीनें लोड करें',
  loadMoreTransactions: 'और ट्रांजैक्शन लोड करें',
  loadMoreUsers: 'और यूजर्स लोड करें',
  loadedBookings: 'लोड की गई बुकिंग',
  loadedDlqItems: 'लोडेड DLQ आइटम',
  loadedFuelLogs: 'लोड किए गए फ्यूल लॉग',
  loadedOwnerBookings: '{count} मालिक बुकिंग लोड{suffix}',
  loading: 'लोड हो रहा है...',
  loadingDashboard: 'डैशबोर्ड लोड हो रहा है...',
  location: 'स्थान',
  lockConfirm: '🔒 लॉक पुष्टि करें',
  lockMachine: 'मशीन लॉक करें',
  lockWarning: 'Teltonika GPS के जरिए मशीन का इग्निशन दूर से बंद हो जाएगा।',
  locked: 'लॉक',
  loginAs: 'लॉगिन हो रहे हैं',
  loginChangeRole: 'भूमिका बदलें',
  loginClientPortalSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन करें',
  loginEmailHint: 'एडमिन लॉगिन के लिए रजिस्टर्ड ईमेल इस्तेमाल करें।',
  loginFailedGeneric: 'लॉगिन असफल — कृपया फिर से प्रयास करें',
  loginIAmQuestion: 'मैं कौन…?',
  loginModeOtp: 'OTP लॉगिन',
  loginModePassword: 'पासवर्ड',
  loginNewHereRegister: 'नए हैं? रजिस्टर करें',
  loginOtpDevHint: 'Development: SMS न हो तो server log में OTP देखें।',
  loginOtpHint: 'रजिस्टर्ड मोबाइल पर 6 अंकों का OTP भेजा जाएगा।',
  loginOtpSentTo: 'OTP भेजा:',
  loginOwnerPortalSubtitle: 'अपनी फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन करें',
  loginPhoneHint: 'क्लाइंट, ओनर और ऑपरेटर लॉगिन के लिए रजिस्टर्ड मोबाइल नंबर इस्तेमाल करें।',
  loginPickRoleHint: 'पंजीकृत? भूमिका चुनें। नए हैं? नीचे Join Us।',
  loginPortalAdminSubtitle: 'प्लेटफ़ॉर्म नियंत्रण और अनुमोदन',
  loginPortalAdminTitle: 'एडमिन पोर्टल',
  loginPortalClientSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन',
  loginPortalClientTitle: 'क्लाइंट पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन और दैनिक लॉग के लिए साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन',
  loginPortalOwnerTitle: 'मालिक पोर्टल',
  loginRoleAdminDesc: 'प्लेटफ़ॉर्म नियंत्रण, अनुमोदन और संचालन',
  loginRoleClientDesc: 'निर्माण परियोजनाओं के लिए मशीनरी बुक करें',
  loginRoleClientShort: 'क्लाइंट',
  loginRoleOperatorDesc: 'नियुक्त मशीन और दैनिक लॉग',
  loginRoleOwnerDesc: 'फ्लीट, कमाई और उपलब्धता प्रबंधित करें',
  loginRoleOwnerShort: 'ओनर',
  loginSendOtp: 'OTP भेजें',
  loginSendingOtp: 'OTP भेज रहे हैं...',
  loginSignInShort: 'साइन इन',
  loginTabOtp: 'OTP',
  loginTabPassword: 'पासवर्ड',
  loginVerifyOtp: 'Verify करें',
  loginVerifyingOtp: 'Verify हो रहा है...',
  logout: 'लगआउट',
  sessionRevokedAlert: 'तपाईं अर्को उपकरणमा लग इन हुनुहुन्छ। कृपया पुनः लगइन गर्नुहोस्।',
  machine: 'मशीन',
  machineDefaultLabel: 'मशीन',
  machineDetails: 'मशीन और ऑपरेटर विवरण',
  machineDetailsTitle: 'मशीन विवरण',
  machineDispatchedAt: 'मशीन भेजी गई — {when}',
  machineHours: 'मशीन घंटे',
  machineIdLabel: 'मशीन ID',
  machineInfo: 'मशीन की जानकारी',
  machineLabel: 'मशीन',
  machineLog: 'मशीन लॉग',
  machineReg: 'मशीन पंजीकरण फॉर्म',
  machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत पडताळणी करेल.',
  machineRegistrationTitle: 'मशीन पंजीकरण',
  machineStatus: 'मशीन स्थिति',
  machineStatusTitle: 'मशीन स्थिति',
  machines: 'मशीनें',
  marketingBackHome: 'वेबसाइट होम',
  marketingBadge: 'लाइव ऑपरेशन · कराड, सातारा',
  marketingBuiltFor: 'सटीकता, अनुपालन और गति चाहने वाली भारतीय निर्माण टीमों के लिए।',
  marketingCtaBook: 'मशीन बुक करें',
  marketingCtaLogin: 'Development Express खोलें — लॉगिन',
  marketingCtaWhatsApp: 'WhatsApp करें',
  marketingFooterRights: '2026 डेवलपमेंट एक्सप्रेस · कराड, सातारा',
  marketingHeadline: 'महाराष्ट्र का अग्रणी मशीनरी रेंटल प्लेटफॉर्म',
  marketingLead: 'रीयल-टाइम GPS, डिजिटल वॉलेट भुगतान, और निर्माण मशीनरी के लिए स्वचालित संचालन। 2011 से सेवा में।',
  marketingNavContact: 'संपर्क',
  marketingNavLogin: 'प्लेटफॉर्म लॉगिन →',
  marketingNavServices: 'सेवाएँ',
  marketingNavTech: 'प्रौद्योगिकी',
  marketingServicesTitle: 'हम क्या देते हैं',
  marketingStatDigital: 'डिजिटल भुगतान',
  marketingStatFleet: 'लाइव मशीनें',
  marketingStatYears: 'वर्षों का अनुभव',
  marketingSvcOps: 'पूर्ण संचालन सूट',
  marketingSvcOpsSub: 'मालिक, ऑपरेटर, क्लाइंट — एक प्लेटफॉर्म।',
  marketingSvcPay: 'केवल वॉलेट निपटान',
  marketingSvcPaySub: 'GST इनवॉइस — साइट पर नकद नहीं।',
  marketingSvcTrack: 'GPS और लाइव स्थिति',
  marketingSvcTrackSub: 'Teltonika से जुड़ी फ्लीट दृश्यता।',
  marketingTechLead: 'Development Express बुकिंग, अनुपालन और फील्ड टेलीमेट्री को एक ही वर्कफ़्लो में जोड़ता है।',
  md: 'MD',
  mediumTrend: 'MEDIUM ट्रेंड',
  minAdvanceRequired: 'न्यूनतम अग्रिम आवश्यक',
  minimumAdvance: 'न्यूनतम अग्रिम आवश्यक',
  minimumRecharge: 'UPI/कार्ड/QR के लिए न्यूनतम ₹1।',
  moUnit: 'महीने',
  mobileNumber: 'मोबाइल नंबर',
  monthMachineSummary: 'इस महीने की मशीनें',
  monthTotalLabel: 'महीने का कुल',
  months: 'महीने',
  moreAvailable: 'और उपलब्ध',
  myBookings: 'मेरो बुकिङ',
  myClientRating: 'मेरी क्लाइंट रेटिंग',
  myMachines: 'मेरी मशीनें',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'नेट कमाई (माह)',
  netPaid: 'नेट भुगतान',
  netPayable: 'शुद्ध देय',
  netReceived: 'नेट प्राप्त',
  netReceivedCaps: 'नेट प्राप्त',
  neverText: 'कभी नहीं',
  newBooking: 'नई बुकिंग',
  newClientRegister: 'नया क्लाइंट? यहां रजिस्टर करें',
  newClientRegistration: 'नया क्लाइंट पंजीकरण',
  newPassword: 'New password',
  nextText: 'आगे',
  noAlerts: 'कोई अलर्ट नहीं!',
  noAlertsNow: 'अभी कोई अलर्ट नहीं।',
  noBankRefund: '❌ बैंक रिफंड नहीं — केवल वॉलेट क्रेडिट',
  noBookings: 'कोई सक्रिय बुकिंग नहीं',
  noBookingsAccount: 'इस खाते के लिए अभी तक कोई बुकिंग नहीं।',
  noBookingsYet: 'अभी तक कोई बुकिंग नहीं',
  noClientFeedbackYet: 'अभी कोई क्लाइंट रेटिंग नहीं। डिस्पैच के बाद क्लाइंट फीडबैक यहाँ दिखेगा।',
  noDlqItems: 'कोई DLQ आइटम नहीं',
  noFileSelected: 'कोई फ़ाइल नहीं',
  noMachinesDashboard: 'अभी कोई मशीन नहीं। फ्लीट जोड़ने के लिए मशीन पंजीकरण करें।',
  noMachinesTrack: 'ट्रैक करने के लिए कोई मशीन नहीं',
  noMachinesTrackHint: 'GPS ट्रैकिंग के लिए मशीन पंजीकृत करें।',
  noMachinesYet: 'अभी कोई मशीन पंजीकृत नहीं',
  noMoreAuditLogs: 'वर्तमान फिल्टर के लिए और ऑडिट लॉग नहीं मिले।',
  noRecentApiSloBreach: 'हाल में कोई API SLO breach संकेत नहीं।',
  noRecentFailedLogins: 'हाल में कोई असफल लॉगिन प्रयास नहीं।',
  noRefund: 'नो रिफंड नीति',
  noSecuritySignalsFound: 'कोई सुरक्षा संकेत नहीं मिले।',
  noTransactionsFilter: 'चयनित फ़िल्टर के लिए कोई लेनदेन नहीं।',
  normalText: 'सामान्य',
  off: 'बंद',
  officeLabel: 'ऑफिस',
  on: 'चालू',
  operator: 'ऑपरेटर',
  operatorFeedbackColumn: 'ऑपरेटर फीडबैक',
  operatorFeedbackSaved: 'धन्यवाद! आपका फीडबैक सेव हो गया।',
  operatorFeedbackSubmitted: 'आपका फीडबैक',
  operatorFeedbackTitle: 'ऑपरेटर फीडबैक',
  operatorPortal: 'अपरेटर पोर्टल',
  operatorRole: 'ऑपरेटर',
  operatorSatisfactionQuestion: 'क्या आप ऑपरेटर से संतुष्ट हैं?',
  operatorSuggestionPlaceholder: 'सुझाव या फीडबैक (वैकल्पिक)',
  operators: 'ऑपरेटर',
  optionalLabel: '(वैकल्पिक)',
  otpCode: 'OTP code',
  overview: 'अवलोकन',
  ownerBookingsAllLoaded: ' (सभी लोड)',
  ownerBookingsMoreAvailable: ' (और उपलब्ध)',
  ownerInfo: 'मालिक की जानकारी',
  ownerPortal: 'मालिक पोर्टल',
  ownerRole: 'मशीन मालिक',
  owners: 'मालिक',
  password: 'पासवर्ड',
  passwordsMustMatch: 'Password and confirm password must match.',
  pastIssuesTitle: 'पिछली समस्याएं',
  payNow: 'अभी भुगतान करें',
  payNowText: 'अभी भुगतान करें',
  paymentBreakdownTitle: 'भुगतान विवरण — अप्रैल 2026',
  paymentCycle: 'भुगतान चक्र',
  paymentFailed: 'पेमेंट अयशस्वी! कृपया पुन्हा प्रयत्न करा.',
  paymentHistory: 'भुगतान इतिहास',
  paymentHistoryTitle: 'भुगतान इतिहास',
  paymentMethods: 'भुगतान के तरीके',
  paymentMode: 'भुगतान मोड',
  paymentSuccess: 'पेमेंट यशस्वी!',
  pdfInvoiceFailed: 'इनवॉइस PDF नहीं बन सका। पुनः प्रयास करें।',
  pdfReportFailed: 'रिपोर्ट PDF नहीं बन सका। पुनः प्रयास करें।',
  pdiCompleted: '✅ PDI / सुरक्षा निरीक्षण पूर्ण',
  pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) आवश्यक नहीं — RTO पंजीकृत नहीं।',
  pdiInfo: 'PDI निरीक्षण',
  pdiInsuranceApplicable: '✅ बीमा / कवर (यदि लागू)',
  pdiInsuranceValid: '✅ बीमा वैध और अद्यतन',
  pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
  pdiTitle: 'प्री-डिलीवरी निरीक्षण (PDI)',
  penaltyDeduct: 'रद्दीकरण दंड (1 घंटा)',
  pending: 'लंबित',
  pendingApproval: 'स्वीकृति लंबित',
  pendingCount: '{count} लंबित',
  pendingDispatch: 'डिस्पैच प्रतीक्षेत',
  perDay: 'प्रति दिन',
  perHour: 'प्रति घंटा',
  perMonth: 'प्रति माह',
  perWeek: 'प्रति सप्ताह',
  phone: 'फ़ोन',
  platform: 'निर्माण व्यवस्थापन प्लेटफर्म',
  platformAgreement: 'प्लेटफॉर्म समझौता',
  policyLabel: 'नीति',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट समय',
  portalBackLink: 'पोर्टल',
  portalClient: 'क्लाइंट',
  portalClientSub: 'मशीनरी बुक करें',
  portalNewClientRegister: 'नए क्लाइंट? रजिस्टर करें',
  portalNewOwnerRegister: 'नए ओनर? रजिस्टर करें',
  portalOwner: 'ओनर',
  portalOwnerSub: 'फ्लीट प्रबंधन',
  portalStaffAdmin: 'एडमिन',
  portalStaffOperator: 'ऑपरेटर',
  portalWelcome: 'स्वागत है',
  portalWelcomeHint: 'जारी रखने के लिए अपना पोर्टल चुनें',
  quantityLabel: 'मात्रा',
  quickIssueReport: 'त्वरित समस्या रिपोर्ट',
  quickRechargeUpi: 'UPI से त्वरित रिचार्ज',
  quickSelect: 'त्वरित चयन:',
  rateCard: 'दर पत्रक (ऑपरेटर सहित)',
  rateLimitTelemetryTitle: 'रेट लिमिट टेलीमेट्री',
  rateOperatorWork: 'ऑपरेटर का काम रेट करें (1–5 स्टार)',
  rating: 'रेटिंग',
  receiptId: 'रसीद ID',
  recentAlerts: 'हाल की चेतावनियाँ',
  recentFailedLoginsTitle: 'हाल की असफल लॉगिन',
  recentLabel: 'हाल का',
  recharge: 'रिचार्ज',
  rechargeFirst: '⚡ पहले वॉलेट रिचार्ज करें',
  rechargeWallet: '+ वालेट रिचार्ज',
  ref: 'संदर्भ संख्या',
  refreshText: 'रिफ्रेश',
  refreshingText: 'रिफ्रेश हो रहा है...',
  regCapacitySpecs: 'क्षमता / विवरण',
  regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरीद इनवॉइस, फोटो और ID। बीमा वैकल्पिक।',
  regDocWheeledHint: 'व्हील्ड: RC (RTO), बीमा, PUC और ID (अधिकतम 5MB प्रत्येक)।',
  regEquipmentCategory: 'उपकरण श्रेणी *',
  regFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
  regFileSizeError: 'प्रत्येक दस्तावेज़ अधिकतम 5MB',
  regFileTypeError: 'केवल PDF, JPG, PNG या WEBP अनुमत',
  regFleetIdOptional: 'फ्लीट / चेसिस ID (वैकल्पिक)',
  regMachineCategory: 'मशीन श्रेणी *',
  regMachineInfoTitle: 'मशीन जानकारी',
  regMachineIntro: 'केवल निर्माण heavy equipment — कोई ट्रक/ट्रांसपोर्ट नहीं। व्हील्ड (JCB 3DX) के लिए RTO; क्रॉलर (Poclain) साइट पर — RTO passing नहीं।',
  regMachineNameModel: 'मशीन नाम / मॉडल',
  regMobilityTracked: 'क्रॉलर',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer — साइट उपकरण, RTO passing नहीं',
  regMobilityWheeled: 'व्हील्ड',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) वाला निर्माण उपकरण',
  machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
  machineOwnershipType: 'स्वामित्व प्रकार',
  machineOwnershipNew: 'नई मशीन',
  machineOwnershipUsed: 'मूल मालिक',
  machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
  machinePurchasePrice: 'खरीद मूल्य (₹)',
  machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
  machinePurchaseDate: 'खरीद तिथि',
  machineYearOfManufacture: 'निर्माण वर्ष',
  machineLoanSection: 'इस मशीन पर मेरा loan है',
  machineLoanAmount: 'Loan राशि (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan अवधि (महीने)',
  machineLoanStartDate: 'Loan शुरू तिथि',
  machineFuelConsumption: 'ईंधन खपत (L/hr)',
  machineMonthlyOperatingExpenses: 'मासिक सञ्चालन खर्च',
  machineOperatorMonthlySalary: 'अपरेटर मासिक तलब',
  machineServiceMonthly: 'सेवा / मर्मत (मासिक)',
  machineBreakdownMonthly: 'ब्रेकडाउन / मर्मत (मासिक औसत)',
  machineMaterialsMonthly: 'सामग्री / उपभोग्य (मासिक)',
  recoveryPlan: 'रिकभरी योजना',
  recoveryOnTrack: 'सही बाटोमा',
  recoveryNeedsAttention: 'ध्यान आवश्यक',
  recoveryActionRequired: 'कारबाही आवश्यक',
  recoveryAddPrice: 'रिकभरी योजना हेर्न खरिद मूल्य थप्नुहोस्',
  recoveryProgress: 'लगानी वसूली',
  recoveryDailyNet: 'दैनिक खुद्रा आय',
  recoveryDays: 'पुनःप्राप्ति अवधि',
  recoveryProjectedDate: 'अनुमानित पुनःप्राप्ति मिति',
  recoveryRoi: 'वार्षिक प्रतिफल',
  recoveryCurrentValue: 'हालको मेसिन मूल्य',
  editFinancialDetails: 'वित्तीय विवरण सम्पादन गर्नुहोस्',
  financialDetailsSaved: 'वित्तीय विवरण सुरक्षित भयो',
  recoveryBackfillNudge: 'रिकभरी ट्र्याकिङ अनलक गर्न {{count}} मेसिन(हरू) मा खरिद विवरण थप्नुहोस्',
  dieselPriceTitle: 'डिजेल मूल्य',
  dieselPriceUpdate: 'डिजेल मूल्य अपडेट गर्नुहोस्',
  dieselPriceLatest: 'पछिल्लो मूल्य',
  dieselPriceNoRecord: 'डिजेल मूल्य रेकर्ड छैन',
  dieselPricePerLitre: 'प्रति लिटर मूल्य (₹)',
  dieselQuantity: 'भरिएको मात्रा (लिटर)',
  dieselTaluka: 'सहर / क्षेत्र',
  bookingAttachment: 'एट्याचमेन्ट छान्नुहोस्',
  bookingAttachmentNone: 'कुनै विशिष्ट एट्याचमेन्ट छैन',
  bookingWorkDescription: 'कामको विवरण',
  bookingWorkDescriptionPlaceholder: 'जस्तै आधार खन्ने, ट्रेन्चिङ, पाइपलाइन काम',
  bookingAttachmentLabel: 'एट्याचमेन्ट',
  bookingSiteLabel: 'साइट',
  bookingWorkLabel: 'काम',
  termsAccept: "म नियम तथा सर्तहरूमा सहमत छु",
  termsRequired: "दर्ताका लागि नियम तथा सर्तहरू स्वीकार गर्नुपर्छ",
  termsLink: "नियम तथा सर्तहरू",
  clientBlacklisted: "ब्ल्याकलिस्ट",
  clientBlacklistReason: "ब्ल्याकलिस्टको कारण",
  clientBlacklistConfirm: "यो क्लाइन्टलाई ब्ल्याकलिस्ट गर्ने हो?",
  clientUnblacklist: "ब्ल्याकलिस्टबाट हटाउनुहोस्",
  blacklistedClients: "ब्ल्याकलिस्ट क्लाइन्टहरू",
  blacklistedClientsEmpty: "कुनै ब्ल्याकलिस्ट क्लाइन्ट छैनन्",
  managerAccessRestricted: "वित्त पहुँच प्रतिबन्धित। ओम चवानलाई सम्पर्क गर्नुहोस्।",
  managerSection: "म्यानेजरहरू",
  managerAdd: "म्यानेजर थप्नुहोस्",
  managerName: "म्यानेजरको नाम",
  managerEmail: "म्यानेजर इमेल",
  managerPassword: "अस्थायी पासवर्ड",
  managerCreated: "म्यानेजर खाता सिर्जना भयो",
  managerCredentialsTitle: "म्यानेजर लगइन विवरण",
  managerCredentialsSubtitle: "यी विवरण अहिले सुरक्षित राख्नुहोस् — पासवर्ड पछि फिर्ता पाइँदैन",
  managerCredentialsSaved: "मैले विवरण सुरक्षित राखेको छु",
  managerLoginUrl: "लगइन URL",
  managerActivity: "मेनेजर गतिविधि",
  managerActivityEmpty: "अहिलेसम्म कुनै गतिविधि रेकर्ड भएको छैन",
  managerActivityViewAll: "सबै गतिविधि हेर्नुहोस्",
  onboardingTitle: "सुरु गर्नुहोस्",
  onboardingAccountApproved: "खाता स्वीकृत",
  onboardingKycComplete: "KYC प्रमाणीकरण पूरा",
  onboardingKycPending: "KYC प्रमाणीकरण पूरा गर्नुहोस्",
  onboardingKycRejected: "KYC अस्वीकृत — कृपया पुनः पेश गर्नुहोस्",
  onboardingWalletFunded: "वालेटमा रकम छ",
  onboardingWalletEmpty: "बुकिङका लागि वालेट रकम थप्नुहोस्",
  pushEnablePrompt: "तुरुन्त अपडेटका लागि पुश सूचनाहरू अन गर्नुहोस्",
  downloadDisputeStatement: "विवाद विवरण डाउनलोड गर्नुहोस्",
  downloadInvoice: "इनभ्वाइस डाउनलोड गर्नुहोस्",
  bookAgain: "फेरि बुक गर्नुहोस्",
  machineNoLongerAvailable: "मेसिन अब उपलब्ध छैन",
  downloadHistoryPdf: "इतिहास PDF डाउनलोड गर्नुहोस्",
  onboardingFirstBooking: "आफ्नो पहिलो बुकिङ गर्नुहोस्",
  onboardingAllDone: "तपाईं तयार हुनुहुन्छ!",
  onboardingTrackerTitle: "अनबोर्डिङ प्रगति",
  onboardingTrackerTarget: "अनबोर्डिङ लक्ष्य: 48 घण्टा",
  onboardingTrackerInProgress: "प्रगतिमा",
  onboardingTrackerActionRequired: "कारबाही आवश्यक",
  onboardingTrackerComplete: "पूरा",
  onboardingTrackerPending: "पेन्डिङ",
  onboardingTrackerPhase1: "दर्ता",
  onboardingTrackerPhase2: "KYC प्रमाणीकरण",
  onboardingTrackerPhase3: "मेसिन दर्ता",
  onboardingTrackerPhase4: "पहिलो बुकिङ तयार",
  onboardingTrackerHelper1: "मेसिन दर्ता खोल्न आधार + सेल्फी अपलोड गर्नुहोस्",
  onboardingTrackerHelper2: "KYC समीक्षामा — सामान्यतया 24 घण्टाभित्र",
  onboardingTrackerHelper3: "KYC अस्वीकृत — कागजात पुनः पेश गर्नुहोस्",
  onboardingTrackerHelper4: "KYC स्वीकृत — आफ्नो पहिलो मेसिन थप्नुहोस्",
  onboardingTrackerHelper5: "मेसिन एड्मिन समीक्षामा",
  onboardingTrackerHelper6: "मेसिन लाइभ — पहिलो बुकिङको प्रतीक्षा",
  onboardingTrackerPhaseLabel: "चरण",
  alertsAndNotifications: 'अलर्ट र सूचनाहरू',
  dieselFuelCostPerHour: 'प्रति घण्टा इन्धन लागत',
  dieselPercentOfRate: 'तपाईंको घण्टा दरको',
  dieselPriceSaved: 'डिजेल मूल्य सुरक्षित भयो',
  dieselRateSuggestion: 'दर सुझाव',
  dieselRateIncrease: 'डिजेल बढ्यो — दर बढाउने विचार गर्नुहोस्',
  dieselRateDecrease: 'डिजेल घट्यो — बुकिङका लागि दर घटाउनुहोस्',
  dieselSuggestedRate: 'सुझाइएको दर',
  dieselHistory: 'मूल्य इतिहास',
  dieselNoHistory: 'अहिलेसम्म डिजेल मूल्य इतिहास छैन',
  dieselColDate: 'मिति',
  dieselColPrice: 'मूल्य/लिटर',
  dieselColQty: 'मात्रा',
  dieselColSource: 'स्रोत',
  dieselUploadReceipt: 'रसिद अपलोड',
  dieselExtractSuccess: 'रसिदबाट निकालियो',
  dieselExtractFailed: 'निकाल्न सकिएन — कृपया म्यानुअल प्रविष्ट गर्नुहोस्',
  applyRateSuggestion: '₹{{rate}}/घण्टा लागू गर्नुहोस्',
  rateSuggestionApplied: 'दर सफलतापूर्वक अपडेट भयो',
  marketPosition: 'बजार स्थिति',
  marketBelowMarket: 'बजारभन्दा कम',
  marketCompetitive: 'प्रतिस्पर्धात्मक',
  marketAboveMarket: 'बजारभन्दा माथि',
  marketNoData: 'तपाईंको क्षेत्रका लागि अहिले बजार डाटा छैन',
  marketSubmitRate: 'बजार दर पेश गर्नुहोस्',
  marketCity: 'सहर / क्षेत्र',
  marketMinRate: 'तपाईंको क्षेत्रमा न्यूनतम दर (₹/घण्टा)',
  marketMaxRate: 'तपाईंको क्षेत्रमा अधिकतम दर (₹/घण्टा)',
  marketRateSubmitted: 'बजार दर पेश भयो — धन्यवाद!',
  marketDataPoints: '{{count}} पेशमा आधारित',
  marketRange: '{{city}} मा बजार',
  marketSourceLocal: '{{city}} क्षेत्रका दरमा आधारित',
  marketSourcePlatform: 'प्लेटफर्म-व्यापी दरमा आधारित',
  regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
  regRtoNumber: 'RTO पंजीकरण संख्या *',
  regSelectType: 'प्रकार चुनें…',
  regSubmitBtn: '✅ पंजीकरण जमा करें',
  regTagNoRto: 'RTO नहीं',
  regTagRto: 'RTO',
  regYearManufacture: 'निर्माण वर्ष *',
  register: 'मशीन पंजीकरण',
  registerAction: 'रजिस्टर करें',
  registerMachine: 'मशीन पंजीकरण',
  registering: 'रजिस्टर हो रहा है...',
  registrationPending: 'एडमिन 24 घंटे के भीतर आपका अकाउंट सक्रिय करेगा।',
  registrationSuccess: 'रजिस्ट्रेशन सफल!',
  remoteLockAlert: 'Teltonika GPS स्थापित होने के बाद रिमोट लॉक सक्षम होगा। DE सपोर्ट से संपर्क करें।',
  remoteLockMachine: '🔒 रिमोट लॉक मशीन',
  replaceFile: 'बदलें',
  reportText: 'रिपोर्ट',
  reports: 'प्रतिवेदन',
  resetMethodEmail: 'Email link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'Could not reset password. Request a new link.',
  resetPasswordIntro: 'Choose a strong password with at least 8 characters.',
  resetPasswordMinLength: 'Password must be at least 8 characters.',
  resetPasswordMissingToken: 'Reset link is missing or invalid. Use Forgot password from login.',
  resetPasswordSubmit: 'Update password',
  resetPasswordSuccess: 'Password updated. Redirecting to login...',
  resetPasswordTitle: 'Set new password',
  resetPasswordUpdating: 'Updating...',
  resetText: 'रीसेट',
  retryDlqItemTitle: 'DLQ आइटम पुनः प्रयास',
  retryFailedForDlq: 'DLQ आइटम के लिए पुनः प्रयास विफल',
  retryReasonAuditPlaceholder: 'पुनः प्रयास का कारण (ऑडिट हेतु)',
  retryText: 'पुनः प्रयास',
  revenue: 'राजस्व',
  running: 'चालू',
  satisfiedNo: 'संतुष्ट नहीं',
  satisfiedYes: 'हाँ, संतुष्ट',
  save: 'सहेजें',
  scanToPay: 'भुगतान के लिए स्कैन करें',
  scheduleColFeedback: 'फीडबैक',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'कुल',
  scheduleColType: 'प्रकार',
  securitySignalsTitle: 'सुरक्षा संकेत',
  selectBook: 'यह मशीन बुक करें →',
  selectCalc: '📋 चुनें और लागत देखें →',
  selectFile: 'फ़ाइल चुनें',
  selectMachineFirst: 'पहले मशीन चुनें',
  selectQty: 'मात्रा चुनें',
  selectRole: 'भूमिका छान्नुहोस्',
  selectedMachineText: 'चयनित मशीन',
  send: 'भेजें',
  sendEmail: 'ईमेल भेजें',
  sendWhatsapp: 'WhatsApp पर भेजें',
  settlements: 'निपटान',
  show: 'दिखाएं',
  signIn: 'साइन इन',
  signingIn: 'लगइन हुँदैछ...',
  signupCompanyName: 'कंपनी का नाम',
  signupContactName: 'संपर्क नाम',
  signupCreatePassword: 'पासवर्ड बनाएं',
  signupReenterPassword: 'पासवर्ड दोबारा दर्ज करें',
  signupSectionCompany: 'कंपनी',
  signupSectionContact: 'आपका विवरण',
  signupSectionSecurity: 'सुरक्षा',
  sinceExcellence: '2011 से · 15 वर्ष उत्कृष्टता',
  sinceLabel: 'से',
  sloBreachRisk: 'SLO breach जोखिम',
  sloHealthy: 'SLO स्वस्थ',
  speed: 'गति',
  staleText: 'पुराना',
  status: 'स्थिति',
  statusCancelled: 'रद्द',
  bookingClosed: 'बन्द',
  sectionNew: 'नयाँ',
  sectionAccepted: 'स्वीकृत',
  sectionActive: 'सक्रिय',
  sectionDispatched: 'डिस्प्याच',
  sectionCompleting: 'पूरा हुँदै',
  sectionDisputed: 'विवादित',
  sectionCompleted: 'पूर्ण',
  sectionClosed: 'बन्द',
  statusCompleted: 'पूर्ण',
  stopped: 'बंद',
  submit: 'जमा करें',
  submitOperatorFeedback: 'फीडबैक भेजें',
  submittedRegistrations: 'जमा पंजीकरण',
  support: 'सहयोग',
  supportPolicyBooking: 'केवल वॉलेट अग्रिम। साइट पर नकद नहीं।',
  supportPolicyCancellation: '1 घंटे का जुर्माना; शेष वॉलेट में।',
  supportPolicyContact: 'केवल DE सपोर्ट — सीधा ऑपरेटर संपर्क वर्जित।',
  supportPolicyGst: 'सभी इनवॉइस पर 18% GST; रिपोर्ट टैब से डाउनलोड।',
  supportPolicyHours: 'सोम–शनि, 9–7 IST',
  tableAtt: 'उप',
  tableChange: 'बदलाव',
  tableDay: 'दिन',
  tableEnd: 'समाप्त',
  tableHrs: 'घं',
  tableId: 'आईडी',
  tableIn: 'इन',
  tableLevel: 'स्तर',
  tableMonth: 'महीना',
  tableNote: 'नोट',
  tableOut: 'आउट',
  tableStart: 'शुरू',
  tagline: 'पूर्वाधारको सुनौलो मान',
  tax: 'कर',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express कमीशन: सकल बिलिंग का 15%',
  termFuel: 'मशीन में हमेशा 40%+ ईंधन रखें',
  termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारा स्थापित',
  termGstTcs: 'GST TCS: GST नियमों के अनुसार 1%',
  termNoDirectContact: 'सीधा क्लाइंट संपर्क = तत्काल अनुबंध समाप्ति',
  termPaymentDays: 'क्लाइंट निपटान के 3 कार्य दिवसों में भुगतान',
  termTds: 'TDS कटौती: आयकर अधिनियम के अनुसार 2%',
  threeWorkingDays: '3 कार्य दिवस',
  timeLabel: 'समय',
  todayText: 'आज',
  topSourceIp: 'शीर्ष स्रोत IP',
  total: 'कुल',
  totalAdvanceLabel: 'अग्रिम भुगतान',
  totalBookingsText: 'कुल बुकिंग',
  totalMachines: 'कुल मशीनें',
  totalSpent: 'कुल खर्च',
  tracking: 'GPS ट्रैकिंग',
  transactionHistoryTitle: 'लेनदेन इतिहास',
  transactions: 'लेनदेन इतिहास',
  trustStatCompliant: 'अनुपालन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  txnDescription: 'विवरण',
  type: 'प्रकार',
  understood: '✅ समझ गया — प्लेटफॉर्म उपयोग करूंगा',
  understoodAction: 'समझ गया',
  unknownText: 'अज्ञात',
  updateFuel: 'फ्यूल अपडेट करें',
  updateText: 'अपडेट करें',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'अपलोड',
  valEmail: 'वैध ईमेल आवश्यक',
  valMachineName: 'मशीन नाम / मॉडल आवश्यक',
  valMachineType: 'उपकरण श्रेणी चुनें',
  valMobility: 'व्हील्ड या क्रॉलर उपकरण प्रकार चुनें',
  valOwnerName: 'मालिक का नाम आवश्यक',
  valPdiChecks: 'सभी आवश्यक जांचें पुष्टि करें',
  valPdiRequired: 'PDI पुष्टि आवश्यक',
  valPhone: 'वैध फ़ोन नंबर आवश्यक',
  valRto: 'व्हील्ड मशीनों के लिए RTO नंबर आवश्यक',
  valUploadMissing: 'अपलोड करें: {docs}',
  valYear: 'वैध वर्ष (YYYY) आवश्यक',
  viewMachines: '→ मशीनें देखें',
  wallet: 'वालेट',
  walletBalance: 'वालेट ब्यालेन्स',
  walletCredit: 'वॉलेट क्रेडिट',
  walletDebit: 'वॉलेट डेबिट',
  walletDeduct: '50% अग्रिम वॉलेट से · नकद नहीं · काम पूर्ण होने पर GST चालान',
  walletInsufficient: '❌ अपर्याप्त',
  walletLowRecharge: 'वॉलेट शेष कम — अगली बुकिंग से पहले रिचार्ज करें',
  walletOnly: 'केवल वालेट · नगद स्वीकारिँदैन',
  walletOnlyPolicyDesc: 'सभी लेनदेन केवल वॉलेट से। नकद स्वीकार नहीं।',
  walletOnlyPolicyTitle: 'केवल वॉलेट नीति',
  walletRechargeTitle: 'वॉलेट रिचार्ज',
  walletSufficient: '✅ आगे बढ़ें',
  weeks: 'सप्ताह',
  whatsapp: 'WhatsApp',
  wksUnit: 'सप्ताह',
  year: 'वर्ष',
  yearsExperience: '{n} वर्ष',
  yourMessage: 'अपना प्रश्न या समस्या लिखें...',
  // --- Recent feature strings ---
  retryLabel: 'पुनः प्रयास गर्नुहोस्',
  payrollPreview: 'तलब पूर्वावलोकन',
  payrollRun: 'तलब चलाउनुहोस्',
  payrollAlreadyRun: 'यो महिनाको तलब पहिले नै चलिसकेको छ',
  payrollGross: 'कुल तिर्नुपर्ने',
  payrollNet: 'खुद तिर्नुपर्ने',
  payrollAdvanceDeducted: 'अग्रिम कटौती',
  payrollRunSuccess: 'तलब सफलतापूर्वक चलियो',
  payrollNoAmount: 'यो महिनाको लागि तिर्नुपर्ने रकम छैन',
  payrollMonth: 'तलब महिना',
  exportPayrollCsv: 'तलब CSV निर्यात',
  payrollExportMonth: 'तलब निर्यात महिना',
  payrollDailyRate: 'दैनिक दर',
  payrollHistory: 'पेरोल इतिहास',
  payrollNoHistory: 'अहिलेसम्म कुनै पेरोल चलेको छैन',
  payrollColMonth: 'महिना',
  payrollColGross: 'कुल',
  payrollColDeduction: 'अग्रिम कटौती',
  payrollColNet: 'शुद्ध तलब',
  payrollColDate: 'मिति',
  downloadPayslip: 'पे स्लिप डाउनलोड',
  payslipTitle: 'मासिक पे स्लिप',
  payslipEarnings: 'आय',
  payslipDeductions: 'कटौती',
  payslipDaysWorked: 'कामका दिन',
  payslipGeneratedBy: 'Development Express द्वारा तयार',
  operatorPayrollTitle: 'मेरो तलब',
  payrollMonthlySalary: 'मासिक तलब',
  payrollCurrentMonth: 'हालको महिना',
  payrollPreviousMonth: 'अघिल्लो महिना',
  ownerAttendanceTitle: 'हाजिरी',
  ownerAttendanceEdit: 'सम्पादन',
  ownerAttendanceSave: 'सेभ',
  ownerAttendanceNoRecords: 'यो महिनाको लागि हाजिरी रेकर्ड छैन',
  ownerAttendanceOverrideSuccess: 'हाजिरी अपडेट भयो',
  ownerSalaryUpdated: 'तलब सफलतापूर्वक अपडेट भयो',
  ownerSalaryEditBtn: 'तलब सम्पादन',
  ownerSalaryNotSet: 'तलब सेट छैन — पेरोलका लागि तलब सेट गर्नुहोस्',
  duration: "अवधि",
  durationLabel: 'अवधि',
  plQuotaLabel: 'PL कोटा',
  plUsed: 'प्रयोग',
  plAllowed: 'अनुमति',
  plRemaining: 'बाँकी',
  plQuotaUpdated: 'PL कोटा अपडेट',
  plQuotaExhausted: 'PL कोटा समाप्त — बिन वेतन अवकाश के रूप में दर्ज',
  plRemainingLabel: 'शेष PL',
  noAttendanceRecords: 'अहिलेसम्म उपस्थिति रेकर्ड छैन',
  noFuelLogs: 'अहिलेसम्म इन्धन लग छैन',
  noIssuesYet: 'अहिलेसम्म कुनै समस्या दर्ता छैन',
  failedToLoad: 'डाटा लोड गर्न सकिएन',
  failedToLoadReport: 'प्रतिवेदन लोड गर्न सकिएन',
  failedToLoadIssues: 'समस्या लोड गर्न सकिएन',
  failedToLoadAlerts: 'अलर्ट लोड गर्न सकिएन',
  noRecordsMonth: 'यो महिनाको लागि रेकर्ड छैन',
  underReview: 'समीक्षाधीन',
  issueResolved: 'समाधान भयो',
  presentDaysLabel: 'उपस्थित दिन',
  halfDaysLabel: 'आधा दिन',
  absentDaysLabel: 'अनुपस्थित दिन',
  totalHmrLabel: 'कुल HMR',
  noActiveBookingIdle: 'कुनै सक्रिय बुकिङ छैन — मेसिन निष्क्रिय',
  siteLocationNotCaptured: 'साइट स्थान दर्ता भएन',
  siteLocationNotAvailable: 'साइट स्थान उपलब्ध छैन',
  bookingRefLabel: 'बुकिङ Ref',
  alertPendingBookings: 'बाँकी बुकिङ',
  alertPendingPayouts: 'बाँकी भुक्तानी',
  alertLowFuel: 'कम इन्धन',
  alertOpenIssues: 'खुला समस्या',
  noMachineRunning: 'हाल कुनै मेसिन चलिरहेको छैन',
  trackingEmptyHint: 'मेसिन पठाइसकेपछि तपाईंको सक्रिय बुकिङ यहाँ देखिनेछ।',
  trackingUpdatedEvery5s: 'हरेक 5 सेकेन्डमा अपडेट',
  fuelLastOperatorUpdate: '(अपरेटरको अन्तिम अपडेट)',
  alertExtensionPending: 'बुकिङ विस्तार विचाराधीन',
  alertConfirmCompletion: 'कृपया काम पूरा भएको पुष्टि गर्नुहोस्',
  alertWalletCredited: 'वालेटमा थपियो',
  alertFeedbackRequest: 'काम पूरा — आफ्नो प्रतिक्रिया साझा गर्नुहोस्',
  noLogsYet: 'अहिलेसम्म कुनै गतिविधि लग गरिएको छैन',
  todayActivityLog: 'आजको गतिविधि लग',
  machineLogSubtitle: 'इन्धन, उपस्थिति, समस्याहरू — स्थानीय सत्र लग',
  timerPaused: 'Timer रोकिएको',
  liveBookingTitle: 'लाइभ बुकिङ',
  machineLogTimerHint: 'Timer Admin ले सुरु गर्छ। तल आफ्नो वास्तविक कामको समय लेख्नुहोस् — समाप्त भएपछि Mark Work Complete क्लिक गर्नुहोस्।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'उपस्थिति',
  ownerAlertBookingPending: 'नयाँ बुकिङ तपाईंको स्वीकृतिका लागि विचाराधीन —',
  ownerAlertBookingHours: 'घण्टा',
  ownerAlertPayoutPending: '₹{{amount}} को भुगतान स्थानान्तरण विचाराधीन',
  ownerAlertFuelLow: 'इन्धन कम',
  ownerAlertFuelRemaining: 'बाँकी',
  ownerAlertIssue: 'समस्या दर्ता',
  iotGpsDevicesActive: 'GPS उपकरण सक्रिय',
  iotDashcamsOnline: 'ड्यासक्याम अनलाइन',
  iotFuelSensorsActive: 'इन्धन सेन्सर सक्रिय',
  iotMachinesLocked: 'मेसिन लक',
  iotDeviceStatus: 'IoT उपकरण स्थिति',
  iotColMachine: 'मेसिन',
  iotColGps: 'GPS',
  iotColLocation: 'स्थान',
  iotColFuel: 'इन्धन %',
  iotColDashcam: 'ड्यासक्याम',
  iotColIgnition: 'इग्निसन',
  iotColAction: 'कार्य',
  iotStatusOnline: 'अनलाइन',
  iotStatusNotConnected: 'जडान भएको छैन',
  iotStatusLive: 'लाइभ',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'लक',
  iotNotConnectedBanner: 'IoT हार्डवेयर अझै स्थापना भएको छैन। Teltonika उपकरण स्थापना पछि GPS, ड्यासक्याम र रिमोट लक सुविधा उपलब्ध हुनेछ।',
  fuelUpdateTitle: 'इन्धन अपडेट',
  fuelSensorAccuracyNote: 'अपरेटरले दर्ता गरेको इन्धन स्तर · म्यानुअल प्रविष्टि',
  bookingsTab: 'बुकिङ',
  unknownLabel: 'अज्ञात',
  naLabel: 'N/A',
  baseLabel: 'आधार',
  qtyLabel: 'मात्रा',
  actualHrsLabel: 'वास्तविक घण्टा',
  auditStatTotal: 'कुल',
  auditStatSecurity: 'सुरक्षा',
  auditStatActors: 'कर्ता',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'गैर-Admin',
  kycDocLicense: 'इजाजतपत्र',
  kycDocAadhaarFront: 'Aadhaar अगाडि',
  kycDocAadhaarBack: 'Aadhaar पछाडि',
  kycDocPoliceVerification: 'प्रहरी प्रमाणीकरण',
  kycVerification: 'KYC प्रमाणीकरण',
  kycNotSubmitted: 'KYC पेश गरिएको छैन',
  kycUnderReview: 'KYC समीक्षाधीन',
  kycVerified: 'KYC प्रमाणित',
  kycRejected: 'KYC अस्वीकृत',
  kycAadhaarFront: 'Aadhaar अगाडि',
  kycAadhaarBack: 'Aadhaar पछाडि',
  kycSelfie: 'सेल्फी',
  kycSubmitBtn: 'KYC कागजात पेश गर्नुहोस्',
  kycSubmitSuccess: 'कागजात पेश — समीक्षाधीन',
  kycResubmit: 'कागजात फेरि पेश गर्नुहोस्',
  adminKycTitle: 'क्लाइन्ट KYC समीक्षा',
  adminKycAllFilter: 'सबै',
  adminKycNoSubmissions: 'अहिलेसम्म KYC पेश भएको छैन',
  adminOwnerKycTitle: 'मालिक KYC समीक्षा',
  adminOwnerKycNoSubmissions: 'अहिलेसम्म कुनै मालिक KYC पेश भएको छैन',
  adminOperatorKycTitle: 'अपरेटर KYC समीक्षा',
  adminOperatorKycNoSubmissions: 'अहिलेसम्म कुनै अपरेटर KYC पेश भएको छैन',
  kycRejectedWarning: 'तपाईंको KYC अस्वीकृत भयो। कृपया कागजातहरू पुनः पेश गर्नुहोस्।',
  kycNotSubmittedHint: 'विश्वसनीय अनुभवका लागि KYC पूरा गर्नुहोस्।',
  kycPendingHint: 'तपाईंको KYC समीक्षाधीन छ।',
  kycGoToTab: 'KYC मा जानुहोस्',
  adminKycApproveBtn: 'स्वीकृत',
  adminKycRejectBtn: 'अस्वीकृत',
  adminKycViewDocs: 'कागजात हेर्नुहोस्',
  adminKycRejectReason: 'अस्वीकृतिको कारण',
  adminKycRereviewBtn: 'पुनः समीक्षा',
  kycPan: 'PAN कार्ड',
  kycOwnerSubmitSuccess: 'कागजातहरू पेश — तपाईंको KYC समीक्षाधीन छ',
  kycLicense: 'ड्राइभिङ लाइसेन्स',
  kycPoliceVerification: 'प्रहरी प्रमाणीकरण',
  kycOperatorSubmitSuccess: 'कागजातहरू पेश — तपाईंको KYC समीक्षाधीन छ',
  operatorKycRejectedAssign: 'यस अपरेटरको KYC अस्वीकृत भयो — पुनः स्वीकृत नहुँदासम्म उनीहरूलाई तोक्न सकिँदैन।',
  operatorsColOperator: 'अपरेटर',
  operatorsColEmail: 'इमेल',
  operatorsColPhone: 'फोन',
  operatorsColDocuments: 'कागजातहरू',
  operatorsColStatus: 'स्थिति',
  operatorsDocumentsBtn: 'कागजातहरू ({{count}})',
  operatorsNoResults: 'कुनै अपरेटर भेटिएन',
  operatorsAllTitle: 'सबै अपरेटर ({{count}})',
  operatorsKycDialogDesc: 'KYC कागजातहरू',
  bookingsCountLabel: '{{count}} बुकिङ',
  complianceDates: 'अनुपालन मितिहरू',
  complianceInsurance: 'बीमा',
  complianceRcBook: 'RC पुस्तक',
  compliancePuc: 'PUC',
  complianceNotSet: 'सेट छैन',
  complianceExpired: 'म्याद सकियो',
  complianceExpiringSoon: 'छिट्टै म्याद सकिन्छ',
  complianceExpiringCritical: '७ दिनमा म्याद',
  complianceValid: 'मान्य',
  complianceUpdateBtn: 'अनुपालन मिति अपडेट गर्नुहोस्',
  complianceSaveBtn: 'सेभ',
  complianceAlertsTitle: 'अनुपालन अलर्ट',
  complianceAllCompliant: 'सबै मेसिन अनुपालनमा ✅',
  complianceColMachine: 'मेसिन',
  complianceColOwner: 'मालिक',
  complianceColInsurance: 'बीमा',
  complianceColRcBook: 'RC पुस्तक',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'सुरु मिति',
  complianceEndDate: 'अन्त्य मिति',
  complianceExtractBtn: 'मिति स्वतः भर्न कागजात अपलोड गर्नुहोस्',
  complianceExtractSuccess: 'मिति निकालियो — सेभ गर्नु अघि जाँच गर्नुहोस्',
  complianceExtractError: 'मिति निकाल्न सकिएन — कृपया म्यानुअल प्रविष्ट गर्नुहोस्',
  complianceExtracting: 'कागजात पढ्दै...',
  serviceHistory: 'सेवा इतिहास',
  serviceLastService: 'अन्तिम सेवा',
  serviceNoRecords: 'अहिलेसम्म कुनै सेवा रेकर्ड छैन',
  serviceNextDue: 'अर्को सेवा बाँकी',
  serviceNextHmr: 'अर्को सेवामा',
  serviceAddLog: 'सेवा लग थप्नुहोस्',
  serviceDate: 'सेवा मिति',
  serviceType: 'सेवा प्रकार',
  serviceHmr: 'सेवा HMR',
  serviceNextDate: 'अर्को सेवा मिति',
  serviceWorkDone: 'गरिएको काम',
  serviceNotes: 'नोट',
  serviceTypeRoutine: 'नियमित',
  serviceTypeMajor: 'प्रमुख',
  serviceTypeBreakdown: 'बिग्राइ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'अन्य',
  serviceOverdue: 'म्याद सकियो',
  serviceDueSoon: 'शीघ्र बाकी',
  fleetAnalytics: 'फ्लीट विश्लेषण',
  analyticsRevenue: 'कुल राजस्व',
  analyticsBookings: 'कुल बुकिंग',
  analyticsHours: 'कुल घंटे',
  analyticsActiveMachines: 'सक्रिय मशीनें',
  analyticsMonthlyTrend: 'मासिक राजस्व प्रवृत्ति',
  analyticsMachineTable: 'मशीन अनुसार राजस्व',
  analyticsNoData: 'यस अवधिमा कुनै पूर्ण बुकिंग छैन',
  analyticsLastBooking: 'अन्तिम बुकिंग',
  analytics3Months: '3 महिना',
  analytics6Months: '6 महिना',
  analytics12Months: '12 महिना',
  adminAnalytics: 'विश्लेषण',
  adminFleetTitle: 'फ्लीट विश्लेषण',
  adminFleetPlatformRevenue: 'प्लेटफर्म राजस्व',
  adminFleetActiveOwners: 'सक्रिय मालिक',
  adminFleetOwnerCol: 'मालिक',
  adminFleetMonthlyTrend: 'मासिक राजस्व प्रवृत्ति',
  adminFleetMachineTable: 'मेसिन अनुसार राजस्व',
  adminFleetNoData: 'यो अवधिमा कुनै पूर्ण बुकिङ छैन',
  adminFinancialIntelligence: 'मेसिन वित्तीय जानकारी',
  adminTotalInvested: 'कुल लगानी',
  adminTotalEarned: 'कुल कमाई',
  adminAvgRecovery: 'औसत वसूली',
  adminBreakEvenRate: 'ब्रेक-इभन दर',
  adminProfitMargin: 'नाफा मार्जिन',
  adminNoFinancialData: 'अहिलेसम्म वित्तीय डाटा भएको मेसिन छैन',
  adminMachineDetail: 'मेसिन विवरण',
  adminCallOwner: 'मालिकलाई कल गर्नुहोस्',
  adminWhatsappOwner: 'WhatsApp मालिक',
  adminMarketRates: 'मार्केट रेट जमा',
  adminMarketRateDelete: 'हटाउनुहोस्',
  adminMarketRateDeleteConfirm: 'यो मार्केट रेट जमा हटाउने?',
  adminMarketRateDeleted: 'मार्केट रेट हटाइयो',
  adminMarketRateNoData: 'अहिलेसम्म कुनै मार्केट रेट जमा छैन',
  marketRateApprove: 'स्वीकृत गर्नुहोस्',
  marketRateReject: 'अस्वीकृत गर्नुहोस्',
  marketRateApproved: 'स्वीकृत',
  marketRateRejected: 'अस्वीकृत',
  marketRatePending: 'पेन्डिङ',
  marketRateReviewed: 'मार्केट रेट समीक्षा भयो',
  marketRatePendingReview: 'तपाईंको दर पेश भएको छ र एडмин समीक्षाको लागि पेन्डिङ छ।',
  marketRateEditApprove: 'सम्पादन र स्वीकृत गर्नुहोस्',
  marketRateEditMin: 'सच्याइएको न्यूनतम दर (₹/घण्टा)',
  marketRateEditMax: 'सच्याइएको अधिकतम दर (₹/घण्टा)',
  adminPayrollOverview: 'तलब सारांश',
  adminPayrollTotalOperators: 'कुल अपरेटर',
  adminPayrollTotalGross: 'कुल देय',
  adminPayrollTotalNet: 'कुल शुद्ध देय',
  adminPayrollNoData: 'यो महिनाको लागि तलब डाटा छैन',
  subTabSchedule: 'तालिका',
  subTabHistory: 'इतिहास',
  subTabAnalytics: 'विश्लेषण',
  clientAnalyticsTitle: 'बुकिङ विश्लेषण',
  clientAnalyticsSpend: 'कुल खर्च',
  clientAnalyticsHours: 'कुल घण्टा',
  clientAnalyticsBookings: 'पूर्ण बुकिङ',
  clientAnalyticsMachines: 'प्रयोग गरिएका मेसिन',
  clientAnalyticsAvgSpend: 'प्रति बुकिङ औसत',
  clientAnalyticsMonthlyTrend: 'मासिक खर्च प्रवृत्ति',
  clientAnalyticsTopMachines: 'शीर्ष मेसिन',
  clientAnalyticsNoData: 'यो अवधिमा कुनै पूर्ण बुकिङ छैन',
  operatorAnalyticsTitle: 'काम विश्लेषण',
  operatorAnalyticsPresentDays: 'उपस्थित दिन',
  operatorAnalyticsHalfDays: 'आधा दिन',
  operatorAnalyticsHmr: 'कुल HMR',
  operatorAnalyticsJobs: 'पूर्ण कार्य',
  operatorAnalyticsIssues: 'रिपोर्ट गरिएका समस्या',
  operatorAnalyticsAvgHmr: 'औसत HMR/दिन',
  operatorAnalyticsMonthlyTrend: 'मासिक काम प्रवृत्ति',
  operatorAnalyticsIssueBreakdown: 'प्रकार अनुसार समस्या',
  operatorAnalyticsRecentJobs: 'हालका कार्य',
  operatorAnalyticsNoData: 'यो अवधिमा कुनै काम रेकर्ड छैन',
  adminServiceAlertsTitle: 'सेवा अलर्ट',
  adminServiceAllOk: 'सबै मेसिनका सेवा रेकर्ड अप-टु-डेट छन् ✅',
  adminServiceNoRecord: 'कुनै रेकर्ड छैन',
  adminServiceColLastService: 'अन्तिम सेवा',
  adminServiceColNextDue: 'अर्को Due',
  adminServiceColServiceStatus: 'सेवा स्थिति',
  adminMachinesColMinHrs: 'न्यूनतम घण्टा',
  adminMachinesColRateDay: 'दर/दिन',
  adminClientName: 'ग्राहकको नाम',
  adminOwnerName: 'मालिकको नाम',
  adminPayoutWallet: 'भुक्तानी वालेट',
  adminFooterMachines: 'मेसिन',
  adminFooterClients: 'ग्राहक',
  adminFooterOwners: 'मालिक',
  auditSeverityCritical: 'गम्भीर',
  auditSeverityHigh: 'उच्च',
  auditSeverityMedium: 'मध्यम',
  auditSeverityNormal: 'सामान्य',
  auditCopyEvent: 'इभेन्ट प्रतिलिपि गर्नुहोस्',
  auditViewDetails: 'विवरण हेर्नुहोस्',
  auditHideDetails: 'विवरण लुकाउनुहोस्',
  auditCopyJson: 'JSON प्रतिलिपि',
  auditNoLogs: 'कुनै अडिट लग छैन',
  auditIntroBanner: 'लगइन, प्रशासक कार्यहरू र सुरक्षा घटनाहरू। फिल्टर लोड गरिएका नतिजाहरूमा लागू हुन्छ; पुराना पङ्क्तिहरूका लागि थप लोड गर्नुहोस्।',
  auditLoaded: 'लोड गरिएको',
  auditMoreAvailable: 'थप उपलब्ध',
  auditEndOfList: 'सूची समाप्त',
  auditFilterActive: 'फिल्टर सक्रिय',
  auditFiltersActive: 'फिल्टर सक्रिय',
  auditSeverityBreakdown: 'गम्भीरता विभाजन (हालको सूची)',
  auditPressSlash: 'कार्य फिल्टरमा फोकस गर्न / थिच्नुहोस्',
  auditFilters: 'फिल्टर',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'सबै भूमिका',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'मेटाडाटा JSON खोज्नुहोस्',
  auditFilterFromPlaceholder: 'सुरु मिति र समय',
  auditFilterToPlaceholder: 'अन्त्य मिति र समय',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'समय क्षेत्र:',
  auditTimezoneSuffix: '(स्थानीय)',
  auditHideCsvOptions: 'CSV स्तम्भ विकल्प लुकाउनुहोस्',
  auditShowCsvOptions: 'CSV स्तम्भ विकल्प देखाउनुहोस्',
  auditCsvColCreatedAt: 'सिर्जना समय',
  auditCsvColAction: 'कार्य',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'मेटाडाटा',
  auditFooterLoaded: 'लोड गरिएको',
  auditFooterLogs: 'अडिट लग',
  auditFooterMoreAvailable: '(थप उपलब्ध)',
  auditFooterAllLoaded: '(सबै लोड गरिएको)',
  auditActor: 'एक्टर',
  auditEntity: 'इकाई',
  auditEventLog: 'इभेन्ट लग',
  notificationCenter: 'सूचनाहरू',
  notifChannelAll: 'सबै',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'इमेल',
  notifChannelPush: 'पुश',
  notifChannelSms: 'SMS',
  notifStatusSent: 'पठाइयो',
  notifStatusFailed: 'असफल',
  notifStatusPending: 'विचाराधीन',
  notifEmpty: 'अहिलेसम्म कुनै सूचना छैन',
  notifLoadMore: 'थप लोड गर्नुहोस्',
  adminNotifLog: 'सूचना लग',
  adminNotifColUser: 'प्रयोगकर्ता',
  adminNotifColRole: 'भूमिका',
  adminNotifNoData: 'अहिलेसम्म कुनै सूचना लग छैन',
  etaOwnerApproval: 'मालिकको स्वीकृतिको प्रतीक्षा',
  etaWorkInProgress: 'अनुमानित समाप्ति',
  etaPaymentDeadline: 'भुक्तानी पुष्टि म्याद',
  etaWorkCompleted: 'काम सम्पन्न भयो',
  etaDisputeReview: 'DE टोली विवाद समीक्षा गर्दैछ',
  etaMinutesRemaining: '{n} मिनेट बाँकी',
  etaHoursRemaining: '{n} घण्टा बाँकी',
  txRecharge: 'वालेट रिचार्ज',
  txBookingAdvance: 'बुकिङ अग्रिम',
  txBookingPayment: 'बुकिङ भुक्तानी',
  txSettlement: 'सेटलमेन्ट',
  txRefund: 'रिफन्ड',
  txPenalty: 'जरिवाना',
  txCommission: 'कमिसन',
  tacTitle: "नियम और शर्तें",
  tacPrivacy: "गोपनीयता नीति",
  tacRefund: "रिफंड नीति",
  tacCancellation: "रद्दीकरण नीति",
  tacServiceDelivery: "सेवा वितरण नीति",
  tacIntro: "बुकिंग से पहले हमारी नीतियाँ देखें",
  tacBannerTitle: "नियम अपडेट उपलब्ध",
  tacBannerOpen: "नियम खोलें",
  tacBannerAgree: "मैंने पढ़ लिया है और सहमत हूँ",
  tacBannerLater: "बाद में",
  clientPoliciesTitle: "ग्राहक नीतियाँ",
  machineGroupAvailable: "उपलब्ध",
  machineGroupBusy: "व्यस्त",
  dewateringReferral: "डीवाटरिंग (पंप) सेवा चाहिए? MachineOS जल्द पंप ठेकेदार सेवाएँ जोड़ेगा। रेफरल के लिए सपोर्ट से संपर्क करें।",
  noActiveWork: "इस महीने कोई सक्रिय कार्य नहीं",
  accountTab: "खाता",
  recentActivity: "हालको गतिविधि",
  goodMorning: "शुभ प्रभात",
  goodAfternoon: "शुभ दिउँसो",
  goodEvening: "शुभ सन्ध्या",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
